import API from '../app.api';
import PublicAPI from '../app.api.public';

export const auth = async (username, password, otpCode = null) => {
    const res = await PublicAPI.post('/api/provider/amc/token', {
        username,
        password,
        otpCode,
    });
    const d = res.data;
    return d;
};

export const getUserProfile = async () => {
    const res = await API.get('/api/provider/amc/me/profile');
    const d = res.data;
    return d;
};

export const getUserPermission = async () => {
    const res = await API.get('/api/provider/amc/me/permission');
    const d = res.data;
    return d;
};

export const getMyVirtualAccounts = async () => {
    const res = await API.get('/api/provider/amc/me/account');
    const d = res.data;
    return d;
};

export const getMyVirtualAccountsWithPermissions = async () => {
    const res = await API.get('/api/provider/amc/me/account/all');
    const d = res.data;
    return d;
};

export const getMyOTPStatus = async () => {
    const res = await API.get(
        '/api/v1/common/user/account/security/totp/enabled'
    );
    const d = res.data;
    return d;
};

export const setupMyOTP = async () => {
    const res = await API.post(
        '/api/v1/common/user/account/security/totp/setup'
    );
    const d = res.data;
    return d;
};

export const removeMyOTP = async ({ otpCode }) => {
    const res = await API.delete('/api/v1/common/user/account/security/totp', {
        data: { otpCode },
    });
    const d = res.data;
    return d;
};

export const checkCurrentOTP = async ({ otpCode }) => {
    const res = await API.post(
        '/api/v1/common/user/account/security/totp/check',
        {
            otpCode,
        }
    );
    const d = res.data;
    return d;
};

export const resetPassword = async (email) => {
    const res = await API.post('/api/v1/common/user/account/reset-password', {
        email,
    });
    return res.data;
};

export const updateInformation = async ({ firstname, lastname }) => {
    const res = await API.put('/api/v1/common/user/account/information', {
        firstname,
        lastname,
    });

    return res.data;
};

export const getTagnameId = async () => {
    if (!process.env.REACT_APP_DRIVE_TAGNAMES) {
        return [];
    }

    const res = await API.get('/api/v1/module/drive/tag');

    const tagNamesEnv = process.env.REACT_APP_DRIVE_TAGNAMES.split(',');
    const filteredTagNames = res.data.data.filter((item) =>
        tagNamesEnv.includes(item.constant)
    );
    let formattedTagNames = [];

    filteredTagNames.forEach((item) => {
        formattedTagNames.push({
            tagNameId: item.id,
            value: item.values,
        });
    });

    return formattedTagNames;
};

export const getPortalModules = async (entityId) => {
    const res = await API.get(
        `/api/v1/module/configuration?entityId=${entityId}`
    );

    return res.data;
};
